
import { BToast, BvToastOptions } from 'bootstrap-vue';
import { Component }              from '$/lib/vueExt';

@Component
export default class Toast extends BToast {

	static showAlert(textToShow: string | Error, toastOptions: BvToastOptions = {}) {
		const text = textToShow instanceof Error ? textToShow.message : textToShow;
		new this().$bvToast.toast(text, { solid : true, variant : 'danger', ...toastOptions });
	}

	static showWarning(textToShow: string, toastOptions: BvToastOptions = {}) {
		this.showAlert(textToShow, { variant : 'warning', ...toastOptions });
	}

	static showSuccess(textToShow: string, toastOptions: BvToastOptions = {}) {
		this.showAlert(textToShow, { variant : 'success', ...toastOptions });
	}

}

